import { decamelizeKeys } from 'humps';

import { apiClient } from '../apiClient';

export const PATHS = {
  ELIGIBILITY_CHECK: '/b2b/api/v4/eligibility_check/',
} as const;

export type EligibilityCheckPayload = {
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  employeeId?: string;
  zipcode?: string;
  orgUuid?: string;
  vidaUserUuid?: string;
  isTester?: boolean;
  gender?: string;
  email?: string;
  healthPlanUuid?: string;
  healthPlanHolderRelation?: string;
  healthPlanHolderFirstName?: string;
  healthPlanHolderLastName?: string;
  healthPlanHolderBirthday?: string;
  healthPlanHolderGender?: string;
};

// Response from POST /eligibility_check. Backend always returns 200 — the
// presence of `successfulMatchMethod` is the only success signal. An empty
// body (`{}`) or one carrying a `code`/`message` is a soft failure that the
// caller surfaces / routes on, not an HTTP error.
export type EligibilityCheckResponse = {
  successfulMatchMethod?: string;
  shouldVerifyEligibilityEmail?: boolean;
  webserverOrgUuid?: string;
  code?: string;
  message?: string;
};

export async function checkEligibility(
  payload: EligibilityCheckPayload
): Promise<EligibilityCheckResponse> {
  const res = await apiClient.post<EligibilityCheckResponse>(
    PATHS.ELIGIBILITY_CHECK,
    decamelizeKeys(payload)
  );
  return res.data ?? {};
}
